// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__3JYr1","login__wrap":"styles_login__wrap__3qd-U","login__title":"styles_login__title__1IZVm","login__container":"styles_login__container__3vcoY"};